// extracted by mini-css-extract-plugin
export default {"caption":"caption_caption__GM2Ef"};